/**
 * How the person signed in this time (owner 2026-10-25: "If I login as email
 * or sms the username is always show signed in as testisp-admin not email or
 * mobile number"). The sign-in page notes the way in and what was typed when
 * the first step is sent; the account menu shows it. Display only, this tab
 * only (sessionStorage); nothing is authorized on it.
 */

export type SignInMethod = "sms" | "email" | "password" | "provider";

export interface SignedInWith {
  method: SignInMethod;
  /** What the person typed (mobile, email, username) or the provider's name. */
  id: string;
}

const KEY = "ankhos.signedInWith";

export function rememberSignIn(method: SignInMethod, id: string): void {
  try {
    window.sessionStorage.setItem(KEY, JSON.stringify({ method, id: id.trim().slice(0, 120) }));
  } catch {
    // Storage unavailable: the menu shows the username only.
  }
}

export function signedInWith(): SignedInWith | null {
  try {
    const v: unknown = JSON.parse(window.sessionStorage.getItem(KEY) ?? "null");
    if (!v || typeof v !== "object") return null;
    const { method, id } = v as Record<string, unknown>;
    if (typeof id !== "string" || !id) return null;
    if (method !== "sms" && method !== "email" && method !== "password" && method !== "provider") return null;
    return { method, id };
  } catch {
    return null;
  }
}

/** "SMS code to 9820217705", "Google", ... for the account menu. */
export function describeSignIn(s: SignedInWith): string {
  switch (s.method) {
    case "sms":
      return `SMS code to ${s.id}`;
    case "email":
      return `email code to ${s.id}`;
    case "password":
      return `password as ${s.id}`;
    default:
      return s.id;
  }
}
